import { connect } from 'react-redux'
import { selectAvailableAccounts } from 'selectors/app/base'
import LoginMultipleAccounts from './view'

const select = state => {
  return {
    accounts: selectAvailableAccounts(state),
  }
}

export default connect(select)(LoginMultipleAccounts)
